import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import BaseLayout from "./layout/BaseLayout";
import Home from "./screens/Home";
import Contact from "./screens/Contact";
import Sponsors from "./screens/Sponsors";
import Team from "./screens/Team";
import SocialCause from "./screens/SocialCause";
import ComingSoon from "./screens/ComingSoon";
import Competitions from "./screens/Competitions";
import Merch from "./screens/Merch";
import Infi from "./screens/Infi";
import Proshows from "./screens/Proshows";
import EventDetails from "./screens/Events";

class BaseRouter extends Component {
  render() {
    return (
      <Switch>
        <BaseLayout>
          <Route exact path="/" component={Home} />
          <Route exact path="/team" component={Team} />
          <Route exact path="/sponsors" component={Sponsors} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path={"/events"} component={ComingSoon} />
          <Route path={"/competitions"} component={Competitions } />
          <Route path={"/social-cause"} component={SocialCause} />
          <Route path={"/merch"} component={Merch} />
          <Route path={"/infi"} component={Infi} />
          <Route path={"/proshows"} component={Proshows} />
          <Route path={"/events/:id"} component={EventDetails}/>
          {/*<Route exact path={'/ca'} component={()=>{*/}
          {/*    window.location.href='https://ca.elan.org.in/';*/}
          {/*    return null;}}/>*/}
        </BaseLayout>
      </Switch>
    );
  }
}

export default BaseRouter;
